import Dashboard from "layouts/Dashboard/Dashboard.jsx";
//import Login from "components/Login/Login.jsx";

var indexRoutes = [{ path: "/", name: "Home", component: Dashboard }];

export default indexRoutes;



// WEBPACK FOOTER //
// ./src/routes/index.jsx